import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { Tooltip } from '@mui/material';


export default function BoxIndicator(props: any) {
  const {
    title,
    indicator,
    percentageLabel,
    previousValue,
    icon
  } = props;

  let iconSymbol = null;
  if(icon){
    iconSymbol = icon === "up" ? 
      <TrendingUpIcon sx={{fontSize: 16}} /> 
      : 
      <TrendingDownIcon sx={{fontSize: 16}}/>;
  }
  return (
    <div className="boxIndicator">
      <div className="boxIndicatorContent">
        <h2>{title}</h2>
        <div className="boxIndicatorContentInner">
          <span className="indicatorValue">{indicator}</span>
          <Tooltip 
            title={`Previous: ${previousValue !== undefined && previousValue !== null ? previousValue : 'N/A'}`}
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#7963ff",
                  color: "white",
                  fontSize: "12px"
                }
              }
            }}
          >
            <span className="percentageLabel">{percentageLabel}%{iconSymbol}</span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
